import { useId, useState } from "react";
import { QRCodeSVG } from "qrcode.react";

// Renders a scannable QR code linking to `path` (resolved against the current origin) —
// the same destination a judge would land on by typing the code in by hand (e.g. the pool
// role picker, or judge join screen). Open by default so a ref/admin can just hold the
// screen up; the toggle collapses it when the card gets too tall to scan past.
// Pass `code` to print the typed-entry code itself in large type above the QR, and
// `caption` to say who should scan it (rendered inside the panel, so it appears and
// disappears with the code rather than dangling over a collapsed one).
export default function CodeQR({ path, label = "Show QR", code, codeLabel = "CODE", caption, size = 200 }) {
  const [open, setOpen] = useState(true);
  const panelId = useId();
  const url = `${window.location.origin}${path}`;

  return (
    <div className="mt-2 flex flex-col items-center" onClick={(e) => e.stopPropagation()}>
      {code && (
        <div className="text-center mb-1.5">
          <div className="font-display text-[10px] font-bold text-gray-500 tracking-widest">{codeLabel}</div>
          <div className="font-display text-3xl font-extrabold tracking-[0.2em] text-white">{code}</div>
        </div>
      )}
      <button type="button" onClick={() => setOpen((o) => !o)} aria-expanded={open} aria-controls={panelId}
        className="text-xs font-display font-bold text-gray-300 tracking-widest bg-transparent border border-gray-400 rounded-lg px-3 py-1.5 cursor-pointer hover:text-white hover:border-gray-300">
        {open ? "Hide QR" : label}
      </button>
        <div id={panelId} hidden={!open} className="p-3 bg-white text-black rounded-xl mt-2 text-center">
          {/* The destination lives in the image's label rather than as visible link text:
              nobody hand-types this URL (they type the code above), but a screen reader
              still needs to know where the code points. */}
          <div role="img" aria-label={`QR code linking to ${url}`} className="inline-block" style={{ lineHeight: 0 }}>
            <QRCodeSVG value={url} size={size} level="M" aria-hidden="true" />
          </div>
          {caption && (
            <div className="font-display text-xs font-bold text-gray-700 tracking-wide mt-2" style={{ maxWidth: size }}>{caption}</div>
          )}
        </div>
    </div>
  );
}
